import React from 'react';
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Auth from 'stores/Auth';

// example url http://localhost:5000/#/authCode?code=wp8dGKUT8tufeA56bNdBUEZexnLq2W

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class AuthCode2 extends React.Component {
	propTypes: {
		auth?: Auth
	};

	render() {
		return (
			<Segment loading={true}>
				<div>Requesting token...</div>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/public/AuthCode2/index.js